module.exports = __webpack_public_path__ + "img/8.f110de27.jpg";